import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";

export default {
  name: "VisitTypeAddEditModal",
  components: { customModal },
  //
  props: {
    editingId: String,
  },
  emits: ["closeModal", "saved", "refreshVisitTypes"],

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      studyId: "",
       visitType: {
        name: "",
        active: "",
      },

      formErrors: {}
    };
  },

//   async mounted() {
//     this.token = store.getters.getIdToken;
//     this.studyId = store.getters.getStudyIs;
//     window.addEventListener("studyIdChanged", async (event) => {

//     this.studyId = store.getters.getStudyIs;

//     });
// //props editing
//  if (this.visitName) {
//   this.visitType.name = this.visitName
// }


//      // Edit Mode → Load from API
//   if (this.editingId) {
//     await this.fetchVisitTypeById();
//   }

//   // Create Mode → Prefill from prop
//   else if (this.visitName) {
//     this.visitType.name = this.visitName;
//   }
//   },

async mounted() {
  this.token = store.getters.getIdToken;
  this.studyId = store.getters.getStudyIs;

  window.addEventListener("studyIdChanged", () => {
    this.studyId = store.getters.getStudyIs;
  });

  // Edit Mode → Load from API
  if (this.editingId) {
    await this.fetchVisitTypeById();
  }

  // Create Mode → Prefill from Prop
  else if (this.visitName) {
    this.visitType.name = this.visitName;
  }
},


  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    validateForm() {
      this.formErrors = {};

      if (!this.visitType.name) {
        this.formErrors.name = "Visit type name is required";
      }

      return Object.keys(this.formErrors).length === 0;
    },

    async fetchVisitTypeById() {
      try {
        const { data } = await axios.get(
          `${this.baseurl}/forms/cra/getcravisittypebyid`,
          {
            params: { id: this.editingId },
            headers: { Authorization: `Bearer ${this.token}` }
          }
        );

        if (!data) return;

        this.visitType.name = data.type;
        this.visitType.active = data.active;
        this.visitType.description = data.description || "";

      } catch (err) {
        console.error("Failed to fetch visit type", err);
      }
    },

    async createVisitType() {
      if (!this.validateForm()) return;

      const payload = {
        type: this.visitType.name,
        // active: this.visitType.active,
        // description: this.visitType.description,
        studyId: this.studyId
      };

      await axios.post(
        `${this.baseurl}/forms/cra/cracreatevisittype`,
        payload,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );

      alert("Visit type created successfully");
      this.$emit("saved");
      this.$emit("refreshVisitTypes");
      this.closeModal();
    },

    async updateVisitType() {
      if (!this.validateForm()) return;

      const payload = {
        visitTypeId: this.editingId,
        type: this.visitType.name,
        studyId: this.studyId
        // active: this.visitType.active,
        // description: this.visitType.description
      };

      await axios.put(
        `${this.baseurl}/forms/cra/updatecravisittype`,
        payload,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );

      alert("Visit type updated successfully");
      this.$emit("saved");
      this.$emit("refreshVisitTypes");
      this.closeModal();
    }
  }
};
